import { Component, OnInit } from '@angular/core';
import { UserServices } from '../services/userservices.service';
@Component({
  selector: 'app-user-faq',
  templateUrl: './user-faq.component.html',
  styleUrls: ['./user-faq.component.scss']
})
export class UserFaqComponent implements OnInit {

 public FAQList: any;
  constructor(private userServices:UserServices) {
    this.getFAQLisT();
   }

  ngOnInit() {
  
  }

  getFAQLisT()
  {
    this.userServices.getFAQ()
            .subscribe(
                (couponData) => { 
                    if (couponData.response == null) {
                      this.FAQList=null
                    }
                    else {
                      this.FAQList = couponData.response.faq

                    }
                    console.log(this.FAQList);
                },
                (error) => {
                    //this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }

            );
   
  }

}



// WEBPACK FOOTER //
// ./src/app/user-faq/user-faq.component.ts